module.exports = __webpack_public_path__ + "img/pub-messenger-new-message.f4bf648a.svg";